import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { createTokenizedComponent, withoutClassName } from './helpers';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
const TokenizedUINumberInput = createTokenizedComponent(UINumberInput);
export default function NumberInputAdapter(_ref) {
  let {
      use
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(commonProps);
    _capturedPropsForTesting = Object.assign({
      use
    }, rest);
    return /*#__PURE__*/_jsx(NumberInput, Object.assign({
      "data-test-id": "NumberInput",
      use: use
    }, rest));
  }
  const adaptedUse = use === 'default' || use === 'on-dark' ? use : undefined;
  _capturedPropsForTesting = Object.assign({
    use: adaptedUse
  }, commonProps);
  return /*#__PURE__*/_jsx(TokenizedUINumberInput, Object.assign({
    "data-test-id": "UINumberInput",
    use: adaptedUse
  }, commonProps));
}